import { render, staticRenderFns } from "./TipoAtendimentoSetting.vue?vue&type=template&id=5cac68b2"
import script from "./TipoAtendimentoSetting.vue?vue&type=script&lang=js"
export * from "./TipoAtendimentoSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports